// extracted by mini-css-extract-plugin
export default {"more_button":"more-button_more_button__cyQYR","icon":"more-button_icon__6nWDw","text":"more-button_text__SIqHO","more_menu_wrapper":"more-button_more_menu_wrapper__e-TeK"};